import Head from 'next/head';
import { useTranslation } from 'next-i18next/pages';

import Login from '@/components/pages/Login';
import { loginPageConfig } from '@/config/pages';
import type { NextPageWithNamespaces } from '@/lib/i18n/page.types';

function LoginPage() {
  const { t } = useTranslation('login');
  const pageTitle = t('pageTitle');

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <Login />
    </>
  );
}

const LoginPageWithNamespaces = LoginPage as NextPageWithNamespaces;

LoginPageWithNamespaces.namespacesRequired = loginPageConfig.namespacesRequired;

export default LoginPageWithNamespaces;
